import http from "../../../http-common.js";

function toError(err) {
  const msg =
    (err && err.response && err.response.data && err.response.data.message) ||
    (err && err.message) ||
    "Something failed!";
  return new Error(msg);
}

export default {
  async loadSummary(context) {
    try {
      const res = await http.get("/ledger/summary");
      if (res.status === 200 && res.data.success) {
        context.commit("setSummary", {
          branches: res.data.branches || [],
          clients: res.data.clients || [],
        });
      } else {
        throw new Error("Failed to load summary.");
      }
    } catch (e) {
      throw toError(e);
    }
  },

  async loadEntries(context, params = {}) {
    try {
      const qs = new URLSearchParams();
      if (params.entity_type) qs.set("entity_type", params.entity_type);
      if (params.entity_id) qs.set("entity_id", params.entity_id);
      if (params.entry_type) qs.set("entry_type", params.entry_type);
      if (params.startDate) qs.set("startDate", params.startDate);
      if (params.endDate) qs.set("endDate", params.endDate);
      if (params.page) qs.set("page", params.page);
      if (params.limit) qs.set("limit", params.limit);
      const url = qs.toString() ? `/ledger/entries?${qs}` : "/ledger/entries";
      const res = await http.get(url);
      if (res.status === 200 && res.data.success) {
        context.commit("setEntries", {
          entries: res.data.entries,
          pagination: res.data.pagination,
        });
      } else {
        throw new Error("Failed to load entries.");
      }
    } catch (e) {
      throw toError(e);
    }
  },

  async loadBalance(context, params) {
    try {
      const { entity_type, entity_id } = params || {};
      const url = `/ledger/balance/${encodeURIComponent(entity_type)}/${encodeURIComponent(entity_id)}`;
      const res = await http.get(url);
      if (res.status === 200 && res.data.success) {
        context.commit("setBalance", res.data);
      } else {
        throw new Error("Failed to load balance.");
      }
    } catch (e) {
      throw toError(e);
    }
  },

  async loadCategories(context, applicable_to) {
    try {
      const url = applicable_to
        ? `/ledger/categories?applicable_to=${encodeURIComponent(applicable_to)}`
        : "/ledger/categories";
      const res = await http.get(url);
      if (res.status === 200 && res.data.success) {
        context.commit("setCategories", res.data.categories);
      } else {
        throw new Error("Failed to load categories.");
      }
    } catch (e) {
      throw toError(e);
    }
  },

  async postManualEntry(_ctx, payload) {
    try {
      const res = await http.post("/ledger/manual", payload);
      if (res.status === 200 && res.data.success) {
        return res.data.ledger_entry_id;
      }
      throw new Error("Failed to post entry.");
    } catch (e) {
      throw toError(e);
    }
  },

  async createCategory(_ctx, payload) {
    try {
      const res = await http.post("/ledger/categories", payload);
      if (res.status === 200 && res.data.success) return res.data.id;
      throw new Error("Failed to create category.");
    } catch (e) {
      throw toError(e);
    }
  },

  async updateCategory(_ctx, { id, ...payload }) {
    try {
      const res = await http.put(`/ledger/categories/${id}`, payload);
      if (res.status === 200 && res.data.success) return true;
      throw new Error("Failed to update category.");
    } catch (e) {
      throw toError(e);
    }
  },
};
